export default "__VITE_ASSET__CRPZXvro__"